import { UserInfo } from '@/model/common'
import { BjaxEx } from '@bilibili/ogv-yora'
import Mock from '@bilibili/bapi-mock'
import { isDev, isUat, isPre, isProd } from '../utils/common'

const env = isProd ? '' : isPre ? '' : 'uat-'

const http = new BjaxEx({
  // 'bapi.bilibili.co/mock/4533'
  baseURL: `//${env}api.bilibili.com`,
})

const prefix = isUat ? 'uat-' : isPre ? 'pre-' : ''
const host = `//${prefix}api.bilibili.com`

let HOST = {
  activity: host,
  common: host,
  fe: 'http://activity.hdslb.com',
}

if (isUat || isDev) {
  const mock = new Mock()
  HOST = mock.getMockPath(HOST)
}

// eslint-disable-next-line
export const getUserInfo = async (): Promise<UserInfo | unknown> =>
  await http.get(
    `${HOST.common}/x/web-interface/nav`,
    {
      ts: new Date().getTime(),
    },
    {
      noErrTip: true,
    }
  )

export default http
